import color from "../../../assets/jss/color";
import {
  primaryColor,
  primaryBoxShadow,
  whiteColor,
  blackColor,
  grayColor,
  hexToRgb
} from "../../../assets/jss/material-dashboard-pro-react.jsx";

const styles = theme => ({
  title: {
    paddingLeft: 0,
    marginBottom: "10px !important",
    maxWidth: "100%",
    textAlign: "left",
    color: "rgb(9, 64, 102)"
  },
  formCard: {
    "&&": {
      border: "1px solid rgba(9, 64, 102, 0.16)",
      borderRadius: 18,
      boxShadow: "0 18px 42px rgba(9, 64, 102, 0.12)",
      padding: theme.spacing(3, 3.5),
      "@media (max-width: 600px)": {
        padding: theme.spacing(2)
      }
    }
  },
  errorBlock: {
    minHeight: 0,
    marginBottom: theme.spacing(1)
  },
  formBody: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.25),
    width: "100%",
    minWidth: 0,
    "@media (max-width: 420px)": {
      gap: theme.spacing(1)
    }
  },
  sectionPanel: {
    width: "100%",
    minWidth: 0,
    boxSizing: "border-box",
    borderBottom: "1px solid rgba(9, 64, 102, 0.12)",
    padding: theme.spacing(0, 0, 2.25),
    "&:not(:first-child)": {
      paddingTop: theme.spacing(1.25)
    },
    "&:last-child": {
      borderBottom: 0,
      paddingBottom: 0
    },
    "& .MuiFormControl-root": {
      margin: "0 !important"
    },
    "& .MuiAutocomplete-root": {
      boxShadow: "none !important",
      borderRadius: 8
    },
    "& .MuiOutlinedInput-root": {
      minHeight: 44,
      borderRadius: "8px !important",
      backgroundColor: "#fbfcfe"
    },
    "& .MuiOutlinedInput-input": {
      paddingTop: "9px !important",
      paddingBottom: "9px !important"
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(9, 64, 102, 0.22)"
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(9, 64, 102, 0.48)"
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#094066",
      borderWidth: 2
    },
    "@media (max-width: 420px)": {
      paddingBottom: theme.spacing(1.75)
    }
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.25)
  },
  sectionMarker: {
    width: 24,
    height: 24,
    borderRadius: "50%",
    flex: "0 0 24px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#094066",
    color: "#fff",
    fontSize: 12,
    fontWeight: 800,
    lineHeight: 1
  },
  sectionTitle: {
    color: "#094066",
    fontWeight: 800,
    textAlign: "left",
    fontSize: 17,
    lineHeight: 1.3,
    margin: 0
  },
  fieldLabel: {
    color: "#094066",
    fontWeight: 700,
    fontSize: 13,
    lineHeight: 1.35,
    margin: "0 0 6px",
    display: "block"
  },
  fieldGroup: {
    minWidth: 0,
    marginTop: theme.spacing(1.5),
    "&:first-child": {
      marginTop: 0
    }
  },
  basicInfoStack: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1)
  },
  basicInfoNameRow: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: theme.spacing(1.25),
    "@media (max-width: 640px)": {
      gridTemplateColumns: "1fr",
      gap: theme.spacing(1)
    }
  },
  basicInfoPhoneRow: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) minmax(160px, 0.75fr)",
    gap: theme.spacing(1.25),
    alignItems: "center",
    "@media (max-width: 640px)": {
      gridTemplateColumns: "1fr",
      gap: theme.spacing(1)
    }
  },
  basicInfoPhoneRowWithSms: {
    gridTemplateColumns: "minmax(0, 0.95fr) minmax(145px, 0.65fr) 112px",
    "@media (max-width: 760px)": {
      gridTemplateColumns: "minmax(0, 1fr) minmax(145px, 0.75fr)",
      "& $smsConsentField": {
        gridColumn: "1 / -1",
        justifySelf: "start"
      }
    },
    "@media (max-width: 640px)": {
      gridTemplateColumns: "1fr"
    }
  },
  basicInfoPhoneRowSingle: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr)",
    gap: theme.spacing(0.75),
    alignItems: "start"
  },
  basicInfoField: {
    minWidth: 0,
    "& .MuiFormControl-root": {
      width: "100%",
      margin: "0 !important"
    },
    "& .MuiTypography-root": {
      color: "#094066",
      fontSize: 13,
      fontWeight: 700,
      lineHeight: 1.35,
      margin: "0 0 5px",
      textAlign: "left",
      textTransform: "none"
    },
    "& .MuiOutlinedInput-root": {
      minHeight: 44,
      borderRadius: "8px !important",
      backgroundColor: "#fbfcfe",
      boxShadow: "none !important"
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(9, 64, 102, 0.24) !important"
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(9, 64, 102, 0.48) !important"
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#094066 !important",
      borderWidth: "2px !important"
    },
    "& input": {
      backgroundColor: "transparent !important",
      boxShadow: "none !important",
      color: "#12384f",
      fontWeight: 600,
      padding: "10px 12px !important"
    },
    "& .MuiFormHelperText-root, & [class*='warning']": {
      marginTop: theme.spacing(0.75)
    }
  },
  basicInfoSelectField: {
    transform: "translateY(2px)",
    "& .MuiFormControl-root": {
      marginTop: "0 !important"
    },
    "& .MuiInput-root": {
      width: "100%",
      minHeight: 44,
      display: "flex",
      alignItems: "center",
      border: "1px solid rgba(9, 64, 102, 0.24)",
      borderRadius: 8,
      backgroundColor: "#fbfcfe",
      boxSizing: "border-box",
      transition: "border-color 160ms ease, box-shadow 160ms ease",
      "&:hover": {
        borderColor: "rgba(9, 64, 102, 0.48)"
      },
      "&.Mui-focused": {
        borderColor: "#094066",
        boxShadow: "0 0 0 1px #094066"
      },
      "&:before, &:after": {
        display: "none !important"
      }
    },
    "& .MuiSelect-select": {
      width: "100% !important",
      minWidth: "0 !important",
      height: "auto !important",
      minHeight: "0 !important",
      boxSizing: "border-box",
      border: "0 !important",
      borderRadius: "8px !important",
      boxShadow: "none !important",
      backgroundColor: "transparent !important",
      color: "#12384f !important",
      display: "flex",
      alignItems: "center",
      fontSize: "14px !important",
      fontWeight: "700 !important",
      letterSpacing: "0 !important",
      lineHeight: "1.4 !important",
      padding: "0 36px 0 12px !important",
      textTransform: "none !important"
    },
    "& .MuiSelect-icon": {
      color: "#094066",
      right: 12
    },
    "& .MuiInputBase-input:focus": {
      backgroundColor: "transparent"
    },
    "& .MuiFormHelperText-root": {
      marginLeft: 0
    }
  },
  smsConsentField: {
    alignSelf: "start",
    marginTop: 27,
    minHeight: 44,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(0.5),
    border: "1px solid rgba(9, 64, 102, 0.24)",
    borderRadius: 8,
    backgroundColor: "#fbfcfe",
    boxSizing: "border-box",
    padding: "0 4px 0 10px",
    "& .MuiSwitch-root": {
      flex: "0 0 auto"
    },
    "& .MuiSwitch-colorPrimary.Mui-checked": {
      color: "#094066"
    },
    "& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#094066"
    }
  },
  smsConsentLabel: {
    display: "inline-flex",
    alignItems: "center",
    gap: 3,
    color: "#094066",
    fontSize: 12,
    fontWeight: 800,
    lineHeight: 1,
    whiteSpace: "nowrap"
  },
  smsHelpIcon: {
    color: "#6d7f8b",
    cursor: "help",
    width: "15px !important",
    height: "15px !important"
  },
  locationMethodGrid: {
    display: "grid",
    gridTemplateColumns:
      "minmax(0, 1fr) auto minmax(0, 1fr) auto minmax(0, 1fr)",
    gap: theme.spacing(1),
    alignItems: "stretch",
    "@media (max-width: 780px)": {
      gridTemplateColumns: "1fr"
    }
  },
  mobileConsentText: {
    color: "#526a7a",
    fontSize: 12,
    lineHeight: 1.45,
    margin: "0 0 4px",
    maxWidth: 680,
    fontWeight: 500,
    fontFamily: '"Ubuntu","Helvetica","Arial",sans-serif !important'
  },
  locationMethodCard: {
    appearance: "none",
    border: "1px solid rgba(9, 64, 102, 0.18)",
    borderRadius: 8,
    backgroundColor: "#fbfcfe",
    padding: theme.spacing(1.5),
    minHeight: 84,
    textAlign: "left",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: theme.spacing(0.5),
    transition:
      "border-color 160ms ease, box-shadow 160ms ease, background-color 160ms ease",
    "&:hover": {
      borderColor: "rgba(9, 64, 102, 0.42)",
      backgroundColor: "#fff"
    },
    "&:focus": {
      outline: "3px solid rgba(39, 170, 225, 0.35)",
      outlineOffset: 2
    }
  },
  locationMethodCardSelected: {
    borderColor: "#dd3449",
    backgroundColor: "#fff",
    boxShadow: "0 0 0 1px rgba(221, 52, 73, 0.25)"
  },
  locationMethodTitle: {
    color: "#094066",
    fontWeight: 800,
    fontSize: 15,
    lineHeight: 1.25
  },
  locationMethodText: {
    color: "#526a7a",
    fontWeight: 500,
    fontSize: 13,
    lineHeight: 1.4
  },
  locationMethodOr: {
    alignSelf: "center",
    color: "#6d7f8b",
    fontSize: 12,
    fontWeight: 900,
    letterSpacing: 0,
    lineHeight: 1,
    padding: theme.spacing(0, 0.25),
    textAlign: "center",
    "@media (max-width: 780px)": {
      padding: 0
    }
  },
  mapPicker: {
    marginTop: theme.spacing(1.5),
    border: "1px solid rgba(9, 64, 102, 0.18)",
    borderRadius: 8,
    backgroundColor: "#fff",
    boxShadow: "0 12px 26px rgba(9, 64, 102, 0.11)",
    overflow: "hidden",
    textAlign: "left"
  },
  mapSearchBar: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(1.25, 1.5),
    backgroundColor: "#fbfcfe",
    borderBottom: "1px solid rgba(9, 64, 102, 0.12)"
  },
  mapSearchInputWrap: {
    width: "100%",
    minWidth: 0,
    "& > *": {
      width: "100%",
      outline: "none !important"
    }
  },
  mapSearchAutocomplete: {
    "--gmpx-color-primary": "#094066",
    "--gmpx-color-on-surface": "#12384f",
    "--gmpx-color-outline": "transparent",
    width: "100%",
    minWidth: 0,
    minHeight: 40,
    border: "1px solid rgba(9, 64, 102, 0.22)",
    borderRadius: 8,
    backgroundColor: "#fff",
    boxSizing: "border-box",
    color: "#12384f",
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 1.4,
    outline: "none !important",
    padding: 0,
    "&:focus": {
      borderColor: "#094066",
      boxShadow: "0 0 0 1px #094066",
      outline: "none !important"
    },
    "&:focus-within": {
      borderColor: "#094066",
      boxShadow: "0 0 0 1px #094066",
      outline: "none !important"
    },
    "&::part(input)": {
      border: "0 !important",
      boxShadow: "none",
      outline: "none"
    },
    "&:focus-within::part(input)": {
      border: "0 !important",
      boxShadow: "none",
      outline: "none"
    },
    "&::placeholder": {
      color: "#6d7f8b",
      opacity: 1
    }
  },
  mapStage: {
    position: "relative"
  },
  mapCanvas: {
    width: "100%",
    height: "min(560px, 62vh)",
    minHeight: 460,
    backgroundColor: "#d7e0e6",
    cursor: "crosshair",
    "@media (max-width: 640px)": {
      height: "68vh",
      minHeight: 430
    },
    "@media (max-width: 420px)": {
      height: "70vh",
      minHeight: 400
    }
  },
  mapPinShelf: {
    position: "absolute",
    left: "50%",
    top: theme.spacing(1.5),
    transform: "translateX(-50%)",
    zIndex: 2,
    "@media (max-width: 520px)": {
      top: theme.spacing(1)
    }
  },
  mapPinDragButton: {
    appearance: "none",
    border: "1px solid rgba(221, 52, 73, 0.35)",
    borderRadius: 8,
    backgroundColor: "rgba(255, 255, 255, 0.96)",
    boxShadow: "0 8px 18px rgba(9, 64, 102, 0.18)",
    color: "#094066",
    cursor: "grab",
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
    fontSize: 12,
    fontWeight: 800,
    lineHeight: 1.2,
    maxWidth: "calc(100vw - 64px)",
    padding: theme.spacing(1, 1.1),
    textAlign: "left",
    touchAction: "none",
    userSelect: "none",
    "&:active": {
      cursor: "grabbing"
    }
  },
  mapPinGlyph: {
    width: 24,
    height: 24,
    flex: "0 0 24px",
    borderRadius: "50%",
    backgroundColor: "#dd3449",
    color: "#fff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    lineHeight: 1,
    boxShadow: "0 2px 7px rgba(221, 52, 73, 0.35)"
  },
  mapFloatingPin: {
    position: "fixed",
    zIndex: 9999,
    width: 28,
    height: 28,
    marginLeft: -14,
    marginTop: -14,
    borderRadius: "50%",
    backgroundColor: "#dd3449",
    color: "#fff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 13,
    lineHeight: 1,
    pointerEvents: "none",
    boxShadow: "0 6px 16px rgba(9, 64, 102, 0.28)"
  },
  mapPickerControls: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    backgroundColor: "#fbfcfe",
    borderTop: "1px solid rgba(9, 64, 102, 0.12)",
    "@media (max-width: 620px)": {
      alignItems: "stretch",
      flexDirection: "column"
    }
  },
  mapPickerTitle: {
    color: "#094066",
    fontWeight: 800,
    fontSize: 15,
    lineHeight: 1.3,
    marginBottom: 2
  },
  mapPickerText: {
    color: "#526a7a",
    fontWeight: 500,
    fontSize: 13,
    lineHeight: 1.45
  },
  mapFallbackPanel: {
    border: "1px solid rgba(9, 64, 102, 0.16)",
    borderRadius: 8,
    backgroundColor: "#fbfcfe",
    padding: theme.spacing(1.5, 2),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1.5),
    "@media (max-width: 620px)": {
      alignItems: "stretch",
      flexDirection: "column"
    }
  },
  mapFallbackButton: {
    appearance: "none",
    border: "1px solid #dd3449",
    borderRadius: 8,
    backgroundColor: "#fff",
    color: "#dd3449",
    cursor: "pointer",
    fontWeight: 800,
    minHeight: 40,
    padding: theme.spacing(1, 1.75),
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: "#fff5f7"
    },
    "&:focus": {
      outline: "3px solid rgba(221, 52, 73, 0.24)",
      outlineOffset: 2
    }
  },
  mapPickerCoordinates: {
    color: "#12384f",
    fontFamily: "monospace",
    fontSize: 12,
    fontWeight: 700,
    marginTop: theme.spacing(0.5)
  },
  accountChoicePanel: {
    "& > div": {
      alignItems: "stretch",
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      gap: theme.spacing(1.5),
      "@media (max-width: 520px)": {
        gridTemplateColumns: "1fr"
      }
    },
    "& .MuiGrid-item": {
      width: "100%",
      maxWidth: "100%",
      flexBasis: "100%",
      display: "contents"
    },
    "& > div > div > div": {
      margin: "0 !important",
      width: "100%"
    },
    "& .MuiFormControlLabel-root": {
      width: "100%",
      minHeight: 52,
      boxSizing: "border-box",
      margin: "0 !important",
      padding: "7px 14px 7px 8px",
      border: "1px solid rgba(9, 64, 102, 0.18)",
      borderRadius: 8,
      backgroundColor: "#fbfcfe",
      alignItems: "center",
      transition: "border-color 160ms ease, background-color 160ms ease"
    },
    "& .MuiFormControlLabel-root:hover": {
      borderColor: "rgba(9, 64, 102, 0.42)",
      backgroundColor: "#ffffff"
    },
    "& .MuiFormControlLabel-root:has(.Mui-checked)": {
      borderColor: "#dd3449",
      backgroundColor: "#fff",
      boxShadow: "0 0 0 1px rgba(221, 52, 73, 0.25)"
    },
    "& .MuiFormControlLabel-label": {
      color: "#12384f",
      fontWeight: 700,
      fontSize: 15,
      textTransform: "none"
    }
  },
  addressField: {
    maxWidth: "100%",
    "& > div": {
      width: "100%"
    }
  },
  searchField: {
    width: "100%",
    maxWidth: "100%",
    marginBottom: theme.spacing(1),
    "& .MuiOutlinedInput-root": {
      alignItems: "center",
      borderRadius: 8,
      backgroundColor: "#fbfcfe"
    },
    "& .MuiOutlinedInput-input": {
      lineHeight: "20px",
      padding: "11px 14px !important"
    }
  },
  landGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
    gap: theme.spacing(1.25),
    alignItems: "start",
    "@media (max-width: 760px)": {
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
    },
    "@media (max-width: 420px)": {
      gridTemplateColumns: "1fr"
    }
  },
  landField: {
    "& $inputTitle": {
      marginTop: "0 !important"
    }
  },
  submitRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(1.75),
    borderTop: "1px solid rgba(9, 64, 102, 0.12)",
    "@media (max-width: 600px)": {
      flexDirection: "column-reverse",
      alignItems: "stretch"
    }
  },
  submitButtonWrap: {
    width: "min(100%, 320px)",
    position: "relative",
    "& .MuiButton-root": {
      minHeight: 44,
      borderRadius: 8,
      boxShadow: "0 8px 18px rgba(221, 52, 73, 0.22)"
    },
    "& .MuiButton-root.Mui-disabled": {
      boxShadow: "none",
      backgroundColor: "#d8e0e6",
      color: "#738392"
    },
    "@media (max-width: 600px)": {
      width: "100%"
    }
  },
  submitButtonWrapDisabled: {
    "&:hover:after, &:focus-within:after": {
      content: "attr(data-disabled-message)",
      position: "absolute",
      right: 0,
      bottom: "calc(100% + 10px)",
      zIndex: 3,
      width: "min(280px, calc(100vw - 32px))",
      border: "1px solid rgba(9, 64, 102, 0.14)",
      borderRadius: 8,
      backgroundColor: "#094066",
      boxShadow: "0 10px 24px rgba(9, 64, 102, 0.22)",
      color: "#fff",
      fontSize: 13,
      fontWeight: 700,
      lineHeight: 1.35,
      padding: theme.spacing(1, 1.25),
      textAlign: "left",
      "@media (max-width: 600px)": {
        left: 0,
        right: "auto",
        width: "100%"
      }
    }
  },
  easyButtonStl: {
    paddingLeft: "16px"
  },
  fab: {
    marginTop: "20px",
    marginBottom: "20px"
  },
  legallandlabel: {
    fontWeight: "bold",
    textAlign: "left",
    color: "rgb(9, 64, 102)",
    margin: "0 0 10px"
  },
  serviceareaname: {
    textAlign: "left",
    margin: "4px 0 0",
    color: "#526a7a"
  },
  serviceAreaDiv: {
    border: "1px solid rgba(9, 64, 102, 0.16)",
    borderRadius: 8,
    backgroundColor: "#fbfcfe",
    padding: theme.spacing(1.75, 2),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1.5),
    "@media (max-width: 520px)": {
      alignItems: "stretch",
      flexDirection: "column"
    }
  },
  serviceAreaTitle: {
    textAlign: "left",
    margin: 0,
    color: "#094066",
    fontWeight: 800,
    fontSize: 16,
    lineHeight: 1.3
  },
  changeAreaButton: {
    border: "1px solid rgba(221, 52, 73, 0.45)",
    borderRadius: 8,
    backgroundColor: "#fff",
    color: "#dd3449",
    cursor: "pointer",
    fontWeight: 800,
    minHeight: 38,
    padding: "0 16px",
    "&:hover": {
      backgroundColor: "rgba(221, 52, 73, 0.06)"
    }
  },
  andor: {
    color: color.mcsred,
    textAlign: "center"
  },
  sectiontitle: {
    color: color.mcsdarkblue,
    fontWeight: "bold",
    textAlign: "center"
  },
  promocode: {
    position: "relative"
  },
  godown: {
    position: "relative"
  },
  recaptchabox: {
    margin: "16px 0 0",
    padding: 0
  },
  recaptcha: {
    display: "flex",
    justifyContent: "flex-end",
    "@media (max-width: 600px)": {
      justifyContent: "center"
    }
  },
  validationChoiceError: {
    border: "1px solid #df3f4a",
    borderRadius: "8px",
    boxSizing: "border-box",
    padding: theme.spacing(1.25, 1.5)
  },
  validationInlineMessage: {
    color: "red",
    display: "flex",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontSize: "10px",
    justifyContent: "flex-end",
    lineHeight: "14px",
    marginTop: theme.spacing(0.75),
    textTransform: "uppercase"
  },
  select: {
    padding: "12px 0 7px",
    fontSize: ".75rem",
    fontWeight: "400",
    lineHeight: "1.42857",
    textDecoration: "none",
    textTransform: "uppercase",
    color: grayColor[2],
    letterSpacing: "0",
    "&:focus": {
      backgroundColor: "transparent"
    },
    "&[aria-owns] + input + svg": {
      transform: "rotate(180deg)"
    },
    "& + input + svg": {
      transition: "all 300ms linear"
    }
  },
  selectFormControl: {
    // was: margin: "7px 0 17px 0 !important",
    margin: "4px 0 10px 0 !important",
    "& > div": {
      "&:before": {
        borderBottomWidth: "1px !important",
        borderBottomColor: grayColor[4] + " !important"
      },
      "&:after": {
        borderBottomColor: primaryColor[0] + " !important"
      }
    }
  },
  selectLabel: {
    fontSize: "12px",
    textTransform: "uppercase",
    color: grayColor[2] + " !important",
    top: "8px"
  },
  selectMenu: {
    "& > div > ul": {
      border: "0",
      padding: "5px 0",
      margin: "0",
      boxShadow: "none",
      minWidth: "100%",
      borderRadius: "4px",
      boxSizing: "border-box",
      display: "block",
      fontSize: "14px",
      textAlign: "left",
      listStyle: "none",
      backgroundColor: whiteColor,
      backgroundClip: "padding-box"
    },
    "& $selectPaper $selectMenuItemSelectedMultiple": {
      backgroundColor: "inherit"
    },
    "& > div + div": {
      maxHeight: "266px !important"
    }
  },
  selectMenuItem: {
    fontSize: "13px",
    padding: "10px 20px",
    margin: "0 5px",
    borderRadius: "2px",
    transition: "all 150ms linear",
    display: "block",
    clear: "both",
    fontWeight: "400",
    lineHeight: "2",
    whiteSpace: "nowrap",
    color: grayColor[7],
    paddingRight: "30px",
    "&:hover": {
      backgroundColor: primaryColor[0],
      color: whiteColor,
      ...primaryBoxShadow
    }
  },
  selectMenuItemSelected: {
    backgroundColor: primaryColor[0] + "!important",
    color: whiteColor
  },

  selectMenuItemSelectedMultiple: {
    backgroundColor: "transparent !important",
    "&:hover": {
      backgroundColor: primaryColor[0] + "!important",
      color: whiteColor,
      ...primaryBoxShadow,
      "&:after": {
        color: whiteColor
      }
    },
    "&:after": {
      top: "16px",
      right: "12px",
      width: "12px",
      height: "5px",
      borderLeft: "2px solid currentColor",
      transform: "rotate(-45deg)",
      opacity: "1",
      color: grayColor[2],
      position: "absolute",
      content: "''",
      borderBottom: "2px solid currentColor",
      transition: "opacity 90ms cubic-bezier(0,0,.2,.1)"
    }
  },
  selectPaper: {
    boxSizing: "borderBox",
    borderRadius: "4px",
    padding: "0",
    minWidth: "100%",
    display: "block",
    border: "0",
    boxShadow: "0 2px 5px 0 rgba(" + hexToRgb(blackColor) + ", 0.26)",
    backgroundClip: "padding-box",
    margin: "2px 0 0",
    fontSize: "14px",
    textAlign: "left",
    listStyle: "none",
    backgroundColor: "transparent",
    maxHeight: "266px"
  },
  submit: {
    background: color.mcslightblue,
    "&:hover": {
      backgroundColor: color.mcslightblue
    },
    color: "white",
    marginTop: "20px",
    "text-shadow": "1px 1px 1px grey"
  },
  checkRoot: {
    padding: "14px"
  },
  checked: {
    color: primaryColor[0] + "!important"
  },
  checkedIcon: {
    width: "20px",
    height: "20px",
    border: "1px solid rgba(" + hexToRgb(blackColor) + ", .54)",
    borderRadius: "3px"
  },
  uncheckedIcon: {
    width: "0px",
    height: "0px",
    padding: "9px",
    border: "1px solid rgba(" + hexToRgb(blackColor) + ", .54)",
    borderRadius: "3px"
  },
  label: {
    cursor: "pointer",
    paddingLeft: "0",
    color: grayColor[3],
    fontSize: "14px",
    lineHeight: "1.428571429",
    fontWeight: "400",
    display: "inline-flex",
    transition: "0.3s ease all"
  },
  errorMessage: {
    color: "red"
  },
  addPhoneDiv: {
    paddingLeft: "5px"
  },
  addPhoneBtn: {
    backgroundColor: "white",
    boxShadow: "none",
    border: "1px solid blue",
    color: "rgb(9, 64, 102)",
    borderRadius: "8px",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "rgb(9, 64, 102)",
      color: "white"
    }
  },
  selectStyles: {
    border: "1px solid #ced4da",
    boxShadow: "0 3px 6px 0 grey"
  },
  mainDiv: {
    width: "75%",
    "@media (max-width: 420px)": {
      width: "90%"
    }
  },
  cardPadding: {
    padding: "20px 35px",
    "@media (max-width: 420px)": {
      padding: "20px 5px"
    }
  },
  landDesc: {
    "@media (max-width: 420px)": {
      paddingLeft: "0"
    }
  },
  mobilePadding: {
    "@media (max-width: 420px)": {
      padding: "0 2px"
    }
  },
  mainDivStyles: {
    paddingLeft: "15px"
  },
  titleStyles: {
    color: "#094066",
    marginBottom: "40px",
    fontWeight: "bold",
    textAlign: "left"
  },
  txtColor: {
    color: "#094066",
    marginBottom: "5px"
  },
  inputStyles: {
    width: "100%"
  },
  typography: {
    textAlign: "left",
    color: "rgb(9, 64, 102)",
    marginBottom: "10px"
  },
  inputTitle: {
    margin: "0 0 8px !important",
    textAlign: "left",
    color: "rgb(9, 64, 102)",
    fontWeight: 700,
    fontSize: 13,
    lineHeight: 1.35
  },
  promoCodeText: {
    justifyContent: "left",
    maxWidth: "100%"
  },
  submitBtn: {
    backgroundColor: "#df3f4a",
    borderRadius: "5px",
    width: "50%",
    fontWeight: "bold",
    marginLeft: "15px"
  },
  clearFormText: {
    margin: 0,
    color: "#526a7a",
    textDecoration: "none",
    display: "inline-block",
    fontWeight: 700,
    padding: "8px 0",
    "&:hover": {
      cursor: "pointer",
      color: "#094066"
    }
  },
  noUnderline: {
    "& .MuiInput-underline:before, & .MuiInput-underline:after": {
      borderBottom: "none !important"
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: "none !important"
    }
  },
  bottomSpacer: {
    height: theme.spacing(3)
  }
});
export default styles;
